import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { FunctionComponent } from "react";
import { AlertDialogHeader, AlertDialogFooter } from "./ui/alert-dialog";
import { useBlocker } from "@tanstack/react-router";

interface AlertBlockerProps {
  shouldBlock: boolean;
}

const AlertBlocker: FunctionComponent<AlertBlockerProps> = ({
  shouldBlock,
}) => {
  const { proceed, reset, status } = useBlocker({ condition: shouldBlock });

  return (
    <AlertDialog open={status === "blocked"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unsaved Changes</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to leave?
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel onClick={reset}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={proceed}>Leave</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertBlocker;
